import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=df25c134&scoped=true&"
import script from "./schools.ts?vue&type=script&lang=ts&"
export * from "./schools.ts?vue&type=script&lang=ts&"
import style0 from "./schools.scss?vue&type=style&index=0&id=df25c134&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df25c134",
  null
  
)

export default component.exports